import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Box, Typography } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes__default from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { retrieveContentfulImage } from '../../common/image.js';

var useStyles = makeStyles(function (theme) {
  return {
    title: {
      marginBottom: theme.spacing(8),
      textAlign: "left"
    },
    border: {
      border: "1px dashed ".concat(theme.palette.primary.main)
    },
    img: {
      width: theme.spacing(10),
      height: theme.spacing(10),
      marginTop: -theme.spacing(5),
      borderRadius: "50%"
    },
    subtitle: _defineProperty({
      margin: theme.spacing(3, 0, 0.5, 0)
    }, theme.breakpoints.down("xs"), {
      marginTop: theme.spacing(2)
    })
  };
});
var IconTitleText = function IconTitleText(_ref) {
  var imageTitle = _ref.imageTitle,
    imageUrl = _ref.imageUrl,
    title = _ref.title,
    subtitle = _ref.subtitle,
    description = _ref.description,
    bgColor = _ref.bgColor,
    boxClassName = _ref.boxClassName;
  var classes = useStyles();
  return /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    justifyContent: !title ? "center" : "flex-start"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4",
    component: "h2",
    className: classes.title
  }, title), /*#__PURE__*/React__default.createElement(Box, {
    className: clsx(classes.boxColor, classes.border, boxClassName),
    bgcolor: bgColor,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: 21,
    px: 4,
    pb: 4
  }, imageUrl && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: retrieveContentfulImage(imageUrl, {
      width: 80,
      height: 80
    }),
    className: clsx(classes.img, classes.border),
    alt: imageTitle || ""
  }), /*#__PURE__*/React__default.createElement(Typography, {
    className: classes.subtitle,
    variant: "h4"
  }, subtitle), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1"
  }, description)));
};
IconTitleText.propTypes = {
  bgColor: PropTypes__default.string,
  imageTitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  description: PropTypes__default.string,
  boxClassName: PropTypes__default.string
};

export { IconTitleText as default };
//# sourceMappingURL=IconTitleText.js.map
